<template>
  <div id="plan">
    <div
      id="plan_content"
      class="content"
    >
      <div class="plan-details">
        <button
          class="back-btn"
          @click="closePlan()"
        >
          <div class="arrow">
            <i class="icon-arrow-left icons"></i>
          </div>
          <div class="back_label">
            back to floor plans
          </div>
        </button>
        <div class="detail_block">
          <h1 class="name">
            {{ plan.name }}
          </h1>
          <button
            class="access_btn main-font"
            @click="showAccessible = !showAccessible;"
          >
            <span v-if="!showAccessible">Show Accessible Description</span>
            <span v-else>Hide Accessible Description</span>
          </button>
        </div>
        <div class="detail_block">
          <div class="type">{{ getType(plan.type) }}</div>
          <div class="bath">{{ getBaths }}</div>
          <div class="size">
            {{ plan.conditions[0].interior }} Square Feet
            <span v-show="plan.conditions[0].exterior != '0'">
              ({{ plan.conditions[0].exterior }} Square Foot Exterior)
            </span>
          </div>
          <div class="direction">
            Faces {{ getDir(plan) }}
          </div>
        </div>
        <div
          class="desc accessible_description"
          v-show="showAccessible"
        >
          {{ planDesc }}
        </div>
        <div class="clear">
        </div>
      </div>

      <div class="plan-image-container">
        <a
          class="fancy_container"
          :href="getFPImage"
          :aria-label="'Zoom into ' + plan.name + ' floorplan'"
        >
          <div
            class="plan-image"
            :style="{'background-image': 'url(' + getFPImage + ')'}"
          >
            <button
              class="icon-size-fullscreen icons zoom-btn"
              aria-label="Zoom"
            >
            </button>
          </div>
        </a>
      </div>

      <div class="plan-actions">
        <div class="buttons">
          <div class="action-btn email-floorplan">
            <!-- <button @click="openEmailFloorplan(true)">download pdf</button> -->
            <a
              :href="getPDFurl(plan)"
              target="_blank"
            >
              <button
                class="main-font"
                @click="openEmailFloorplan(true)"
              >
                download {{plan.name}} as pdf
              </button>
            </a>
          </div>

          <!-- <div class="action-btn">
            <button
              class="main-font"
              @click="inquireFloorplanOpen()"
            >
              inquire about this floorplan
            </button>
          -->
          <!-- <div class="action-btn mobile">
            <button @click="viewKP()">view keyplate</button>
          </div>
          <div class="action-btn mobile">
            <button @click="viewBuilding()">view building</button>
          </div> -->
        </div>
        <div class="availability">
          <a
            class="fancy_views"
            :href='viewImg'
            :data-caption="viewCaption"
          ></a>
          <!-- <div class="availability_header">
            <div class="availability_label units_col">
              Suite Number:
            </div>
            <div class="availability_label exposure_col">
              Exposure:
            </div>
          </div>
          <div class="units" v-for="unit in orderedUnits" :key="unit.floor">
            <div class="availability_label units_col">
              {{getUnit(unit)}}
            </div>
            <div class="availability_label exposure_col">
              {{getViewDir(unit.dir)}} <span class="view_btn" @click="openView(unit)">click to see view</span>
            </div>
          </div> -->
          <div class="availability_label_header availability_column">
            <div class="availability_label_header units_col">
              Suite Number:
            </div>
            <div
              class="units"
              v-for="unit in orderedUnits"
              :key="unit.floor"
            >
              <div class="availability_label units_col units">
                {{getUnit(unit)}}
              </div>
            </div>
            <div
              class="units"
              v-if="orderedUnits.length === 0"
            >
              <div class="availability_label units_col units">
                Units
              </div>
            </div>
          </div>
          <div class="availability_label_header availability_column">
            <div class="availability_label_header exposure_col">
              Exposure:
            </div>
            <div
              class="units"
              v-for="unit in orderedUnits"
              :key="unit.floor"
            >
              <div class="availability_label exposure_col units">
                {{getViewDir(unit.dir)}}
                <button
                  class="view_btn"
                  @click="openView(unit)"
                  :name="'see ' + getViewDir(unit.dir) + ' view on floor ' + unit.floor + ' button'"
                  :aria-label="'see ' + getViewDir(unit.dir) + ' view on floor ' + unit.floor + ' button'"
                >
                  click to see view
                </button>
              </div>
            </div>
            <div
              class="units"
              v-if="orderedUnits.length === 0"
            >
              <div class="availability_label units_col units">
                Unavailable
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        aria-label="scroll to top"
        class="icon-arrow-up icons top-btn"
        @click="scrollToTop()"
      >
      </button>
    </div>
  </div>
</template>

<script>
/* global $ */
import EventBus from './../EventBus';

export default {
  name: 'app-plan',
  props: ['plan', 'filters', 'soldUnits', 'section'],
  components: {},
  data() {
    return {
      baseUrl:
        'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/',
      emailFloorplanOpen: false,
      // units: [],
      kpActive: false,
      initFancy: false,
      availableViews: [
        { floor: 6, views: ['n', 's', 'w'] },
        { floor: 10, views: ['n', 's', 'w'] },
        { floor: 15, views: ['n', 's', 'w'] },
        { floor: 20, views: ['n', 'e', 's', 'w'] },
        { floor: 25, views: ['n', 'e', 's', 'w'] }
      ],
      viewFloor: 6,
      viewDir: 'n',
      viewImg: '',
      viewCaption: '',
      inquireOpen: false,
      showAccessible: false
    };
  },
  methods: {
    getType(type) {
      switch (type) {
        case 'one': {
          return '1 Bedroom';
        }
        case 'oneDen': {
          return '1 Bedroom + Den';
        }
        case 'two': {
          return '2 Bedroom';
        }
        case 'twoDen': {
          return '2 Bedroom + Den';
        }
        case 'three': {
          return '3 Bedroom';
        }
        case 'threeDen': {
          return '3 Bedroom + Den';
        }
        default: {
          return 'Studio';
        }
      }
    },
    getViewDir(dir) {
      switch (dir) {
        case 'n': {
          return 'North';
        }
        case 'ne': {
          return 'Northeast';
        }
        case 'e': {
          return 'East';
        }
        case 'se': {
          return 'Southeast';
        }
        case 's': {
          return 'South';
        }
        case 'sw': {
          return 'Southwest';
        }
        case 'w': {
          return 'West';
        }
        case 'nw': {
          return 'Northwest';
        }
        default: {
          return '';
        }
      }
    },
    getDir(plan) {
      let dir = plan.dir;
      if (plan.conditions[0].condition_name !== '') {
        dir = plan.conditions[0].condition_name;
      }
      switch (dir) {
        case 'n': {
          return 'North';
        }
        case 'ne': {
          return 'Northeast';
        }
        case 'e': {
          return 'East';
        }
        case 'se': {
          return 'Southeast';
        }
        case 's': {
          return 'South';
        }
        case 'sw': {
          return 'Southwest';
        }
        case 'w': {
          return 'West';
        }
        case 'nw': {
          return 'Northwest';
        }
        default: {
          return '';
        }
      }
    },
    getUnit(pmSuite) {
      const floor = pmSuite.floor;
      let suite = pmSuite.suite;
      if (suite.length === 1) {
        suite = '0' + suite;
      }
      return floor + suite;
    },
    closePlan() {
      EventBus.$emit('closePlanHome');
    },
    openView(unit) {
      // this.viewsOpened = status;
      this.viewDir = unit.dir;

      // Views adjustment since we only have n e s w views.
      if (this.viewDir === 'nw') {
        this.viewDir = 'w';
      } else if (this.viewDir === 'sw') {
        this.viewDir = 'w';
      } else if (this.viewDir === 'ne') {
        this.viewDir = 'e';
      } else if (this.viewDir === 'se') {
        this.viewDir = 'e';
      }

      const floor = this.getClosestFloor(unit.floor);
      this.viewFloor = floor;

      console.log(this.viewDir, this.viewFloor);
      if (
        this.viewDir === 'e' &&
        (this.viewFloor === 6 || this.viewFloor === 10 || this.viewFloor === 15)
      ) {
        this.viewFloor = 20;
      }

      this.viewImg = `static/views/${this.viewFloor}/${this.viewDir}.jpg`;
      // const dir = this.getD
      this.viewCaption = `<div class="floor">${
        this.viewFloor
      }th Floor</div><div class="dir">Looking ${this.getViewDir(
        this.viewDir
      )}</div>`;
      setTimeout(
        () => {
          $('.fancy_views').click();
        },
        200,
        this
      );
    },
    getClosestFloor(sourceFloor) {
      const targFloor = parseInt(sourceFloor, 10);
      let curr = this.availableViews[0].floor;
      let diff = Math.abs(targFloor - curr);
      for (let val = 0; val < this.availableViews.length; val += 1) {
        const newdiff = Math.abs(targFloor - this.availableViews[val].floor);
        if (newdiff < diff && this.availableViews[val].floor <= targFloor) {
          diff = newdiff;
          curr = this.availableViews[val].floor;
        }
      }
      return curr;
    },
    initFancyBox() {
      if (!this.initFancy) {
        console.log('fancybox init');
        $('.fancy_container').fancybox({
          touch: {
            vertical: false
          },
          btnTpl: {
            close:
              '<button class="fancy-close" aria-label="close" data-fancybox-close><span class="ion-close-round"></span></button>'
          }
        });
        $('.fancy_views').fancybox({
          touch: {
            vertical: false
          },
          btnTpl: {
            close:
              '<button class="fancy-close" aria-label="close" data-fancybox-close><span class="ion-close-round"></span></button>'
          }
        });
        this.initFancy = true;
      }
    },
    getPDFurl(plan) {
      const fpImage = this.plan.conditions[0].images.find(
        img => img.type === 'pdf'
      ).url;
      return this.baseUrl + fpImage;
    },
    inquireFloorplanOpen() {
      this.inquireOpen = true;
      EventBus.$emit('openInquire', this.plan, this.filters);
    },
    scrollToTop() {
      $('#plan_content').animate({ scrollTop: 0 }, 500);
    },
    convertToUnitySuite(pmObj) {
      let floor = pmObj.floor;
      let suite = pmObj.suite;
      if (floor.length === 1) {
        floor = '0' + floor;
      }
      if (suite.length === 1) {
        suite = '0' + suite;
      }
      return floor + suite;
    }
  },
  computed: {
    getBaths() {
      const baths = parseInt(this.plan.filter, 10);
      if (baths === 1) {
        return '1 Bathroom';
      }
      return baths + ' Bathrooms';
    },
    getFPImage() {
      const fpImage = this.plan.conditions[0].images.find(
        img => img.type === 'fp'
      ).url;
      return this.baseUrl + fpImage;
    },
    orderedUnits() {
      const availUnits = [];
      const unitList = this.plan.conditions[0].suites;
      for (let i = 0; i < unitList.length; i += 1) {
        const newUnit = this.convertToUnitySuite(unitList[i]);
        const isSoldUnit = this.soldUnits.filter(
          soldUnit =>
            soldUnit.unit === newUnit.toString() && soldUnit.status === 'sold'
        );
        if (isSoldUnit.length === 0) {
          availUnits.push(unitList[i]);
        }
      }
      return availUnits;
    },
    planDesc() {
      if (this.plan && this.section) {
        const content = this.section.section_content.find(
          data => data.name === this.plan.name
        );
        if (content) {
          return content.content;
        }
        return '';
      }
      return '';
    }
  },
  created() {},
  mounted() {
    setTimeout(
      () => {
        this.initFancyBox();
      },
      250,
      this
    );
    this.plan.conditions[0].suites.sort((a, b) => {
      return parseInt(a.floor, 10) - parseInt(b.floor, 10);
    });

    $('#plan_content').scroll(() => {
      if ($('#plan_content').scrollTop() === 0) {
        $('.top-btn').css('display', 'none');
      } else {
        $('.top-btn').css('display', 'block');
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../globals.scss';

#plan {
  position: absolute;
  top: 0;
  left: 0;
  background-color: $livmoreBeige;
  height: calc(100vh - #{$desktopFooterHeight});
  width: 50%;
  z-index: 15;

  .content {
    height: calc(100vh - #{$desktopFooterHeight});
    overflow-y: auto;
    position: relative;

    .top-btn {
      cursor: pointer;
      border: none;
      //background: $livmoreRed;
      //color: $livmoreBeige;
      background-color: $livmoreBlack;
      color: $livmoreBeige;
      padding: 10px;

      position: fixed;
      bottom: calc(20px + #{$desktopFooterHeight});
      right: calc(30px + 50%);

      display: none;

      &:active {
        transform: scale(0.95);
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .plan-image-container {
    .fancy_container {
      // position: relative;
      display: block;
      outline: none;

      &:focus {
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }

    .plan-image {
      background-color: $livmoreBeige;
      background-blend-mode: multiply;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      height: 440px;
      margin-top: 40px;
      margin-bottom: 40px;

      position: relative;

      button.zoom-btn {
        background: transparent;
        border: none;
        font-size: 28px;
        position: absolute;
        bottom: 0%;
        right: 65px;
        color: black;

        cursor: pointer;

        transition: all 0.5 ease-out;
        user-select: none;
        -webkit-tap-highlight-color: transparent;

        &:active {
          transform: scale(0.95);
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .plan-details {
    text-align: left;
    position: relative;

    padding: 45px 0px 30px;
    margin: 0 60px 25px;
    border-bottom: 2px solid $black;

    .back-btn {
      border: none;
      background: transparent;
      font-family: $mainFont;
      // color: $livmoreRed;
      color: $livmoreBlack;
      display: block;
      text-align: left;
      cursor: pointer;
      transform-origin: left;
      margin-bottom: 10px;

      .arrow {
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;

        i {
          font-size: 20px;
        }
      }

      .back_label {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
      }

      &:active {
        transform: scale(0.95);
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .detail_block {
      display: inline-block;
      float: left;
      width: 50%;

      .name {
        font-size: 1.8rem;
        // color: $livmoreRed;
        color: $livmoreBlack;
        margin-bottom: 1.25rem;
      }

      .type,
      .bath,
      .size,
      .direction {
        line-height: 2;
        text-align: right;
      }
    }
  }

  .plan-actions {
    background-color: $livmoreBeige;
    .availability {
      // width: 55%;
      width: 100%;
      margin: 20px auto;
      // padding-left: 20px;

      a.fancy_views {
        display: none;
        color: red;
      }

      .availability_column {
        display: inline-block;
        min-width: 130px;
        .availability_label_header {
          margin-bottom: 14px;
          font-family: $lato;
          text-transform: capitalize;
          text-align: left;
        }
        .availability_label {
          font-family: $chronicleDeck;
          font-size: 14px;
          text-align: left;
          vertical-align: top;
          line-height: 2;

          &.exposure_col {
            min-width: 50%;

            .view_btn {
              font-family: $mainFont;
              // background-color: $livmoreRed;
              // color: $livmoreBeige;
              // background-color: $livmoreRedAccessible;
              // color: $white;
              background-color: $livmoreBlack;
              color: $livmoreBeige;
              border: none;
              padding: 5px 10px;
              // padding-right: 10px;
              // padding-left: 10px;
              margin-left: 15px;

              cursor: pointer;
              user-select: none;
              -webkit-tap-highlight-color: transparent;

              display: inline-block;

              transition: all 0.5 ease-out;

              &:active {
                transform: scale(0.95);
              }

              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }

      // .availability_header {
      //   margin-bottom: 14px;
      //   .availability_label {
      //     text-transform: capitalize;
      //     font-family: $lato;
      //   }
      // }
      //
      // .availability_label {
      //   font-family: $chronicleDeck;
      //
      //   display: inline-block;
      //   min-width: 32%;
      //   max-width: 50%;
      //   font-size: 14px;
      //   text-align: left;
      //   vertical-align: top;
      //
      //   &.occupancy_col {
      //     min-width: 30%;
      //   }
      //
      //   &.units_col {
      //     min-width: 12%;
      //   }
      //
      //   &.exposure_col {
      //     min-width: 50%;
      //     transition: all 0.5 ease-out;
      //
      //     .view_btn {
      //       background-color: $livmoreRed;
      //       color: $livmoreBeige;
      //       padding: 5px 10px;
      //       margin-left: 15px;
      //
      //       cursor: pointer;
      //       user-select: none;
      //       -webkit-tap-highlight-color: transparent;
      //     }
      //
      //     &:active {
      //       transform: scale(0.95);
      //     }
      //   }
      // }

      .units {
        line-height: 2;
        margin-bottom: 5px;
      }

      .view-views {
        display: inline-block;

        button {
          font-family: $chronicleDeck;
          // background-color: $livmoreRed;
          background-color: $livmoreRedAccessible;
          color: $white;
          width: 160px;
          height: 24px;
          line-height: 22px;
          text-align: center;
          border: none;
          margin-bottom: 1rem;
          font-weight: 400;
          outline: none;

          cursor: pointer;
          transition: all 0.5 ease-out;

          &:active {
            transform: scale(0.95);
          }

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .buttons {
      .action-btn {
        display: inline-block;
        margin-right: 10px;
        margin-left: 10px;

        button {
          font-family: $chronicleDeck;
          // background-color: $livmoreRed;
          // color: $white;
          background-color: $livmoreBlack;
          color: $livmoreBeige;
          // width: 195px;
          height: 30px;
          font-size: 0.85rem;
          // line-height: 26px;
          padding: 5px 20px;
          text-align: center;
          border: none;
          margin-bottom: 1rem;
          font-weight: 400;
          outline: none;
          user-select: none;
          -webkit-tap-highlight-color: transparent;

          cursor: pointer;
          transition: all 0.5 ease-out;

          &:active {
            transform: scale(0.95);
          }

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .email-floorplan {
        button {
          padding: 5px 30px;
        }
      }

      .mobile {
        button {
          display: none;
        }
      }
    }
  }

  .access_btn {
    background-color: $livmoreBlack;
    color: $livmoreBeige;
    // width: 195px;
    height: 30px;
    font-size: 0.85rem;
    // line-height: 26px;
    padding: 5px 20px;
    text-align: center;
    border: none;
    margin-bottom: 1rem;
    font-weight: 400;
    outline: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  .desc {
    margin-top: 1rem;
    float: left;
    line-height: 1.5;
  }
}

@media screen and (min-width: 1281px) and (orientation: landscape) {
  #plan {
    height: calc(100vh - #{$desktopFooterHeight});

    .content {
      height: calc(100vh - #{$desktopFooterHeight});
    }

    .plan-image-container {
      .plan-image {
        i {
        }
      }
    }

    .plan-details {
    }

    .plan-actions {
      .availability {
        .availability_header {
        }

        .availability_label {
          &.occupancy_col {
          }

          &.units_col {
          }

          &.exposure_col {
          }
        }
      }

      .buttons {
        .mobile {
          button {
            // display: inline-block;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  #plan {
    height: calc(100vh - #{$desktopFooterHeight1280});

    .content {
      height: calc(100vh - #{$desktopFooterHeight1280});
    }

    .plan-image-container {
      .plan-image {
        i {
          right: 10%;
        }
      }
    }

    .plan-details {
      padding: 45px 0px 30px;
      margin: 0px 30px 25px;

      .back-btn {
        display: none;
      }
    }

    .plan-actions {
      .availability {
        width: 100%;
        padding-left: 0px;

        .availability_header {
          .availability_label {
          }
        }

        .availability_label {
          min-width: 32%;
          max-width: 33%;
          font-size: 14px;

          &.occupancy_col {
            min-width: 25%;
          }

          &.units_col {
            min-width: 15%;
          }

          &.exposure_col {
            min-width: 50%;
          }
        }
      }

      .availability {
        .availability_column {
          min-width: 130px;
          .availability_label_header {
          }
          .availability_label {
            &.exposure_col {
              min-width: 200px;
            }
          }
        }
      }

      .buttons {
        .mobile {
          button {
            // display: inline-block;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  #plan {
    .content {
    }

    .plan-image-container {
    }

    .plan-actions {
      .availability {
        .availability_column {
          min-width: 130px;
          .availability_label_header {
          }
          .availability_label {
            &.exposure_col {
              // min-width: 50%;
            }
          }
        }
      }
      // .availability {
      //   width: 100%;
      //   padding-left: 0px;
      //
      //   .availability_header {
      //     .availability_label {
      //     }
      //   }
      //
      //   .availability_label {
      //     //
      //     // min-width: 32%;
      //     // max-width: 33%;
      //     font-size: 14px;
      //
      //
      //     &.occupancy_col {
      //       min-width: 25%;
      //     }
      //
      //     &.units_col {
      //       min-width: 15%;
      //     }
      //
      //     &.exposure_col {
      //       min-width: 45%;
      //     }
      //   }
      // }

      .buttons {
        .mobile {
          button {
            display: inline-block;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  #plan {
    height: calc(100vh - 75px);
    .content {
      height: calc(100vh - 75px);
    }

    .plan-image-container {
    }

    .plan-details {
      .buttons {
        .mobile {
          button {
            display: inline-block;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  #plan {
    display: none;

    .top-btn {
      display: none !important;
    }

    .content {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/Plan.vue